var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wealth-statement-loader",attrs:{"data-testid":"wealth-statement-loader"}},_vm._l((3),function(row,index){return _c('SkeletonLoader',{key:index,attrs:{"data-testid":"wealth-statement-loader-item"}},[_c('div',{staticClass:"wealth-statement-loader__row"})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }